import { apiRequest } from "@/server/request";
import type {
  Response,
  UserLoginRequest,
  LoginResponse,
  UserInfoResponse,
  FortAgentPurchaseSignRequest,
  FortAgentPurchaseSignResponse,
  FortAgentTransferSignRequest,
  FortAgentTransferSignResponse,
  FortAgentActivateSignRequest,
  FortAgentActivateSignResponse,
  FortAgentPayMixedFusdRequest,
  FortAgentPayMixedFusdResponse,
  GetFortAgentSkuConfigResponse,
  GetMyFortAgentsResponse,
  GetLpInfoResponse,
  PlatFormResponse,
  SubmitWithdrawOrDepositTxResponse,
  SubmitWithdrawOrDepositTxRequest,
  GetBalanceV2Response,
  GetUserInviteLevelResponse,
  GetInviteLevelConfigRequest,
  GetInviteLevelConfigResponse,
  GetUserInviteTeamRequest,
  GetUserInviteTeamResponse,
  GetWithdrawAndRechargeRecordRequest,
  GetWithdrawAndRechargeRecordResponse,
  TransferFusdRequest,
  TransferFusdResponse,
  GetOpenOrderListRequest,
  GetOpenOrderListResponse,
  GetClosedOrderListRequest,
  GetClosedOrderListResponse,
  GetBinanceSpotEthBtcQuoteResponse,
  GetRiskListResponse,
  EstimateOrderFeesRequest,
  EstimateOrderFeesResponse,
  PlaceOrderRequest,
  PlaceOrderResponse,
  ClosePositionRequest,
  ClosePositionResponse,
  GetUserCexPnlSummaryRequest,
  GetUserCexPnlSummaryResponse,
  GetUserCexOrderTradeStatsRequest,
  GetUserCexOrderTradeStatsResponse,
  GetPlatformCexSymbolDayStatsRequest,
  GetPlatformCexSymbolDayStatsResponse,
  GetSignalRequest,
  GetSignalResponse,
} from "./types";

// ===================== 用户/登录 =====================

export const ApiLogin = (
  data: UserLoginRequest
): Promise<Response<LoginResponse>> => {
  return apiRequest<LoginResponse>({
    url: "/user/login/Login",
    method: "post",
    data,
  });
};

export const ApiGetUserInfo = (): Promise<Response<UserInfoResponse>> => {
  return apiRequest<UserInfoResponse>({
    url: "/game/user/GetUserInfo",
    method: "post",
    data: {},
  });
};

export const ApiGetLpInfo = (
  token0Contract: string,
  token1Contract: string
): Promise<Response<GetLpInfoResponse>> => {
  return apiRequest({
    url: "/game/user/GetLpInfo",
    method: "post",
    data: {
      token0Contract,
      token1Contract,
    },
  });
};
/**
 * 获取平台配置
 * @returns Promise<Response<PlatFormResponse>>
 */
export const ApiGetPlatFormConfig = (): Promise<Response<PlatFormResponse>> => {
  return apiRequest<PlatFormResponse>({
    url: "/game/user/GetPlatFormConfig",
    method: "post",
    data: {},
  });
};

// ===================== Fort Agent =====================

export const ApiFortAgentPurchaseSign = (
  data: FortAgentPurchaseSignRequest
): Promise<Response<FortAgentPurchaseSignResponse>> => {
  return apiRequest<FortAgentPurchaseSignResponse>({
    url: "/game/user/FortAgentPurchaseSign",
    method: "post",
    data,
  });
};

export const ApiFortAgentTransferSign = (
  data: FortAgentTransferSignRequest
): Promise<Response<FortAgentTransferSignResponse>> => {
  return apiRequest<FortAgentTransferSignResponse>({
    url: "/game/user/FortAgentTransferSign",
    method: "post",
    data,
  });
};

export const ApiFortAgentActivateSign = (
  data: FortAgentActivateSignRequest
): Promise<Response<FortAgentActivateSignResponse>> => {
  return apiRequest<FortAgentActivateSignResponse>({
    url: "/game/user/FortAgentActivateSign",
    method: "post",
    data,
  });
};

/** 混合购延期 FUSD 单独支付（中心化扣款，需先对 {@link formatFortAgentPayMixedFusdMessage} 签名） */
export const ApiFortAgentPayMixedFusd = (
  data: FortAgentPayMixedFusdRequest
): Promise<Response<FortAgentPayMixedFusdResponse>> => {
  return apiRequest<FortAgentPayMixedFusdResponse>({
    url: "/game/user/FortAgentPayMixedFusd",
    method: "post",
    data,
  });
};

export const ApiGetFortAgentSkuConfig = (): Promise<
  Response<GetFortAgentSkuConfigResponse>
> => {
  return apiRequest<GetFortAgentSkuConfigResponse>({
    url: "/game/user/GetFortAgentSkuConfig",
    method: "post",
    data: {},
  });
};

export const ApiGetMyFortAgents = (): Promise<
  Response<GetMyFortAgentsResponse>
> => {
  return apiRequest<GetMyFortAgentsResponse>({
    url: "/game/user/GetMyFortAgents",
    method: "post",
    data: {},
  });
};
/**
 * 提交充值或提现交易
 * @param data - 提交交易请求参数
 * @returns Promise<Response<SubmitWithdrawOrDepositTxResponse>>
 */
export const ApiGetBalanceV2 = (): Promise<Response<GetBalanceV2Response>> => {
  return apiRequest<GetBalanceV2Response>({
    url: "/game/user/GetBalanceV2",
    method: "post",
    data: {},
  });
};

export const ApiGetUserInviteLevel = (): Promise<
  Response<GetUserInviteLevelResponse>
> => {
  return apiRequest<GetUserInviteLevelResponse>({
    url: "/game/user/GetUserInviteLevel",
    method: "post",
    data: {},
  });
};

/** 获取团队等级配置（各等级业绩门槛等，按代币合约维度） */
export const ApiGetInviteLevelConfig = (
  data: GetInviteLevelConfigRequest
): Promise<Response<GetInviteLevelConfigResponse>> => {
  return apiRequest<GetInviteLevelConfigResponse>({
    url: "/game/user/GetInviteLevelConfig",
    method: "post",
    data,
  });
};

/** 获取团队成员列表（按代币合约维度） */
export const ApiGetUserInviteTeam = (
  data: GetUserInviteTeamRequest
): Promise<Response<GetUserInviteTeamResponse>> => {
  return apiRequest<GetUserInviteTeamResponse>({
    url: "/game/user/GetUserInviteTeam",
    method: "post",
    data,
  });
};

export const ApiGetWithdrawAndRechargeRecord = (
  data: GetWithdrawAndRechargeRecordRequest
): Promise<Response<GetWithdrawAndRechargeRecordResponse>> => {
  return apiRequest<GetWithdrawAndRechargeRecordResponse>({
    url: "/game/user/GetWithdrawAndRechargeRecord",
    method: "post",
    data,
  });
};

export const ApiSubmitWithdrawOrDepositTx = (
  data: SubmitWithdrawOrDepositTxRequest
): Promise<Response<SubmitWithdrawOrDepositTxResponse>> => {
  return apiRequest<SubmitWithdrawOrDepositTxResponse>({
    url: "/game/user/SubmitWithdrawOrDepositTx",
    method: "post",
    data,
  });
};

/**
 * FUSD（及同通道代币）内部转账：需先对 {@link buildTransferFusdSignMessage} 的字符串做钱包签名再提交。
 * 后端路径以服务端为准，若不一致请改 `url`。
 */
export const ApiTransferFusd = (
  data: TransferFusdRequest
): Promise<Response<TransferFusdResponse>> => {
  return apiRequest<TransferFusdResponse>({
    url: "/game/user/TransferFusd",
    method: "post",
    data,
  });
};

/** 获取当前用户未平仓 CEX 订单（分页） */
export const ApiGetOpenOrderList = (
  data: GetOpenOrderListRequest
): Promise<Response<GetOpenOrderListResponse>> => {
  return apiRequest<GetOpenOrderListResponse>({
    url: "/game/cex/GetOpenOrderList",
    method: "post",
    data,
  });
};

/** 获取当前用户已平仓 CEX 订单（分页） */
export const ApiGetClosedOrderList = (
  data: GetClosedOrderListRequest
): Promise<Response<GetClosedOrderListResponse>> => {
  return apiRequest<GetClosedOrderListResponse>({
    url: "/game/cex/GetClosedOrderList",
    method: "post",
    data,
  });
};

/** 获取 AI 交易风险偏好列表（服务端优先读本地缓存，空则回源并回写） */
export const ApiGetRiskList = (): Promise<Response<GetRiskListResponse>> => {
  return apiRequest<GetRiskListResponse>({
    url: "/game/cex/GetRiskList",
    method: "post",
    data: {},
  });
};

/** 获取 AI 交易信号（/game/cex/GetSignal） */
export const ApiGetSignal = (
  data: GetSignalRequest
): Promise<Response<GetSignalResponse>> => {
  return apiRequest<GetSignalResponse>({
    url: "/game/cex/GetSignal",
    method: "post",
    data,
  });
};

/** 预估当前策略下单手续费（/game/cex/EstimateOrderFees） */
export const ApiEstimateOrderFees = (
  data: EstimateOrderFeesRequest
): Promise<Response<EstimateOrderFeesResponse>> => {
  return apiRequest<EstimateOrderFeesResponse>({
    url: "/game/cex/EstimateOrderFees",
    method: "post",
    data,
  });
};

/** AI 下单（/game/cex/PlaceOrder） */
export const ApiPlaceOrder = (
  data: PlaceOrderRequest
): Promise<Response<PlaceOrderResponse>> => {
  return apiRequest<PlaceOrderResponse>({
    url: "/game/cex/PlaceOrder",
    method: "post",
    data,
  });
};

/** AI 平仓（/game/cex/ClosePosition） */
export const ApiClosePosition = (
  data: ClosePositionRequest
): Promise<Response<ClosePositionResponse>> => {
  return apiRequest<ClosePositionResponse>({
    url: "/game/cex/ClosePosition",
    method: "post",
    data,
  });
};

/** 获取当前用户 CEX 盈亏汇总（今日 + 累计） */
export const ApiGetUserCexPnlSummary = (
  data: GetUserCexPnlSummaryRequest = {}
): Promise<Response<GetUserCexPnlSummaryResponse>> => {
  return apiRequest<GetUserCexPnlSummaryResponse>({
    url: "/game/cex/GetUserCexPnlSummary",
    method: "post",
    data,
  });
};

/** 获取当前用户 CEX 自动/手动下单统计（/game/cex/GetUserCexOrderTradeStats） */
export const ApiGetUserCexOrderTradeStats = (
  data: GetUserCexOrderTradeStatsRequest = {}
): Promise<Response<GetUserCexOrderTradeStatsResponse>> => {
  return apiRequest<GetUserCexOrderTradeStatsResponse>({
    url: "/game/cex/GetUserCexOrderTradeStats",
    method: "post",
    data,
  });
};

/** 获取全平台各交易对某业务日的交易量/盈亏汇总（/game/cex/GetPlatformCexSymbolDayStats） */
export const ApiGetPlatformCexSymbolDayStats = (
  data: GetPlatformCexSymbolDayStatsRequest = {}
): Promise<Response<GetPlatformCexSymbolDayStatsResponse>> => {
  return apiRequest<GetPlatformCexSymbolDayStatsResponse>({
    url: "/game/cex/GetPlatformCexSymbolDayStats",
    method: "post",
    data,
  });
};

/** 顶部 BTC/ETH：Redis 中币安 24h ticker（game 每 30s 拉取），见 `BinanceSpotQuoteItem` */
export const ApiGetBinanceSpotEthBtcQuote = (): Promise<
  Response<GetBinanceSpotEthBtcQuoteResponse>
> => {
  return apiRequest<GetBinanceSpotEthBtcQuoteResponse>({
    url: "/game/user/GetBinanceSpotEthBtcQuote",
    method: "post",
    data: {},
  });
};
